import * as style from "bundle-text:./hero.scss";
import templateHTML from "bundle-text:./template.html";
import {
  getRequiredComponentElements,
  navigateTo,
  scrollToBottom,
} from "../../../scripts/utils/utility";

export class HeroCustom extends HTMLElement {
  private template = () => `
   <style>${style}</style>
    ${templateHTML}
  `;

  private ComponentElements: Map<string, HTMLElement>;
  private ComponentNames = {
    product: ".product",
    contact: ".contact",
  };

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
    this.ComponentElements = getRequiredComponentElements(
      this,
      this.ComponentNames
    );
  }

  handleEvent(event: Event) {
    const target = event.target as HTMLElement;
    if (target.classList.contains("product")) {
      navigateTo("shop.html");
    } else if (target.classList.contains("contact")) {
      scrollToBottom();
    }
  }

  connectedCallback() {
    const product = this.ComponentElements.get(
      this.ComponentNames.product
    ) as HTMLElement;
    const contact = this.ComponentElements.get(
      this.ComponentNames.contact
    ) as HTMLElement;
    product?.addEventListener("click", this);
    contact?.addEventListener("click", this);
  }

  disconnectedCallback() {
    const product = this.ComponentElements.get(
      this.ComponentNames.product
    ) as HTMLElement;
    const contact = this.ComponentElements.get(
      this.ComponentNames.contact
    ) as HTMLElement;
    product?.removeEventListener("click", this);
    contact?.removeEventListener("click", this);
  }

  render() {
    if (this.shadowRoot) {
      this.shadowRoot.innerHTML = this.template().trim();
    }
  }
}

customElements.define("hero-custom", HeroCustom);
